import { useContext, Context } from 'react';
import { ViewModel } from '@steelbuy/ts-shared';

import { CreateEntityDataProviderValue } from '../provider/CreateEntityDataProviderValue';

export const useCreateEntityData = <Model extends ViewModel>(
    v: Context<CreateEntityDataProviderValue<Model>>
): CreateEntityDataProviderValue<Model> => useContext(v);
